export class ApiUrl {
  /**
   * ApiUrl() gives the endpoint for the web api
   */
  public static webapiurl() {
    switch (window.location.host) {
      case 'magnet.agmemod.dashboard.wser.wur.nl':
        return 'https://magnet.agmemod.dashboard.wser.wur.nl/WebApi'
      case 'acc.magnet.agmemod.dashboard.wser.wur.nl':
        return 'https://acc.magnet.agmemod.dashboard.wser.wur.nl/WebApi'
      case 'tst.magnet.agmemod.dashboard.wser.wur.nl':
        return 'https://tst.magnet.agmemod.dashboard.wser.wur.nl/WebApi'
      default:
        return 'http://localhost:50256'
    }
  }
}
